/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `auto` - 자동 생성
 * `manual` - 직접 입력
 * `reference` - 참고곡 기반
 */
export type GenerationModeEnum =
  (typeof GenerationModeEnum)[keyof typeof GenerationModeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerationModeEnum = {
  auto: "auto",
  manual: "manual",
  reference: "reference",
} as const;
